const prefix = 'questionnaire';

export default {
    update: `${prefix}.update`,
};



// WEBPACK FOOTER //
// ./scripts/frontend/base/actions/Questionnaire.js